import {
  DateField,
  useRecordContext,
  RecordContextProvider,
  TabbedShowLayout,
  NumberField,
  // WithRecord,
  useTranslate,
} from "react-admin";
import Box from "@mui/material/Box";

const CustomerListExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <TabbedShowLayout
      syncWithLocation={false}
      sx={{
        m: 4,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
        "& .RaTabbedShowLayout-content": {
          p: 0,
        },
        "& .RaLabeled-label": {
          display: "none",
        },
      }}
    >
      <TabbedShowLayout.Tab label="mine.label.address">
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.name")}</th>
              <th>{t("mine.label.address")}</th>
              <th>{t("mine.label.city")}</th>
              <th>{t("mine.label.postal_code")}</th>
              <th>Phone</th>
              <th>Fax</th>
            </tr>
          </thead>
          <tbody>
            {record.customer_addresses.map((addr, idx) => {
              return (
                <tr key={addr.id}>
                  <td>{addr.location_name}</td>
                  <td>{addr.detail}</td>
                  <td>{addr.city.name}</td>
                  <td>{addr.postal_code ? addr.postal_code : "-"}</td>
                  <td>{addr.phone}</td>
                  <td>{addr.fax ? addr.fax : "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </Box>
      </TabbedShowLayout.Tab>
      {record.sale_orders && record.sale_orders.length ? (
        <TabbedShowLayout.Tab label="Salesmen">
          <Box
            component="table"
            sx={{
              width: "100%",
              // bgcolor: "rgba(0,0,0,.04)",
              // fontSize: "smaller",
              borderCollapse: "collapse",
              "& th, td": {
                padding: "6px 8px",
                border: "1px solid #dddddd",
              },
            }}
          >
            <thead>
              <tr>
                <th>{t("mine.label.code")}</th>
                <th>{t("mine.label.name")}</th>
                <th>{t("mine.label.join_on")}</th>
              </tr>
            </thead>
            <tbody>
              {record.sale_orders.map((sale_order, idx) => {
                return (
                  <tr key={sale_order.salesman.code + idx}>
                    <td>{sale_order.salesman.code}</td>
                    <td>{sale_order.salesman.name}</td>
                    <td>
                      <RecordContextProvider value={sale_order.salesman}>
                        <DateField
                          source="join_on"
                          sx={{
                            fontSize: "inherit",
                          }}
                          options={{
                            year: "numeric",
                            month: "short",
                            day: "2-digit",
                          }}
                        />
                      </RecordContextProvider>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Box>
        </TabbedShowLayout.Tab>
      ) : null}
    </TabbedShowLayout>
  );
};

export default CustomerListExpandList;
